import {atomWithReset} from 'jotai/utils'

export const totalPlayersState = atomWithReset<number>(0)
